import Vue from 'vue'
import Vuex from 'vuex'

import siemens from './siemens'

Vue.use(Vuex)

export default new Vuex.Store({
    // 引用时记得加上modules名：this.$store.state.user.xxx
    modules: {
        siemens
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js